import selectedGenericRefinement from './selected-refinements/selected-generic-refinement';
import selectedSizeRefinement from './selected-refinements/selected-size-refinement';

/**
 * @param {Array<import('../../../../type-definitions').Refinement>} selectedRefinements - selected refinements
 * @param {import('../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} selected refinements HTML
 */
export default (selectedRefinements, refinementURLBuilder, seoUrlConfig) =>
    selectedRefinements?.length > 0
        ? `
        <div class="selected-refinements-ctr">
            <ul class="selected-refinements">
                ${selectedRefinements
                    .map(refinement => {
                        if (refinement.isSizeRefinement) {
                            return selectedSizeRefinement(refinement, refinementURLBuilder, seoUrlConfig);
                        }
                        return selectedGenericRefinement(refinement, refinementURLBuilder, seoUrlConfig);
                    })
                    .join('')}

                <span class="refinements-clear-all js-refinements-toggle" data-toggle="refinements-active"
                    role="button" tabindex="0" title="${window.Resources.SEARCH_REFINEMENT_RESET}"
                    data-url="${refinementURLBuilder.getStartingURL()}">
                    ${window.Resources.SEARCH_REFINEMENT_RESET}
                </span>
            </ul>
        </div>
        `
        : '';
